<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="安全知识主题:" >
        <el-input v-model="searchFactor.theme"></el-input>
      </el-form-item>
      <el-form-item label="安全知识模块:" >
        <el-select v-model="searchFactor.moduleId" placeholder="请选择" style="width:150px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option
            v-for="item in moduleList"
            :key="item.id"
            :label="item.moduleName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateKn">创建</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      :max-height="800"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="模块"
        width="120" >
      </el-table-column>
      <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        width="150" >
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        min-width="300" :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="initFolderName"
        label="资源文件夹"
        width="180">
      </el-table-column>
      <el-table-column
        prop="attachFileName"
        label="附件名称"
        width="180">
      </el-table-column>
      <el-table-column
      prop="active"
      width="70"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
          <span v-else style="color: greenyellow" > 已发布</span>
      </template>
    </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="120"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="100"
        label="更新时间">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveNotice",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewNotice",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditNotice",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"uploadAttach", index:scope.$index,data:scope.row}'><i class="el-icon-upload2" style="color:rgb(40, 238, 10)" ></i> <span>上传附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDeleteAttach",index:scope.$index, data:scope.row}'><i class="el-icon-delete" style="color:rgb(247, 33, 40)" ></i> <span>删除附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      :current-page.sync="pager.currentPage"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount">
    </el-pagination>
    <el-dialog  :close-on-click-modal="false" :visible.sync="dialogVisual.initKnThemeVisual" v-on:close ="clearInitKnForm" >
      <div slot="title" class="dialog-footer">
        <span> 初始化安全知识 </span>
      </div>
      <el-form :model="initKnForm" label-width="20%">
        <el-form-item  label="安全知识主题:">
          <el-input v-model="initKnForm.theme" autocomplete="off" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="安全知识模块:" >
          <el-select v-model="initKnForm.moduleId" placeholder="请选择" style="width:80%">
            <el-option
              v-for="item in moduleList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>
    <!-- 上传附件弹框 -->
    <el-dialog  :close-on-click-modal="false" width="40%" :visible.sync="dialogVisual.initUploadAttachVisual" v-on:close ="clearUplaodAttachForm" >
      <div slot="title" class="dialog-footer">
        <span> 上传附件 </span>
      </div>
      <el-upload
        style="display: inline-block"
        ref='uploadAttach'
        :action="knAttach.url"
        :headers="knAttach.headers"
        :multiple="false"
        :limit="knAttach.limit"
        :name="knAttach.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="true"
        :on-error="fileUpLoadError">
        <el-button  size="mini"  @click="handleUploadAttach()">添加附件</el-button>
      </el-upload>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
  import axios from  '@/api/axiosConfig'
  import SERVICE_URL  from  '@/api/url'
  import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
  import {PAGE_SIZE,MESSAGE_DURATION,fileAreaType,fileType} from  '@/api/constant'
  export default {
      name : 'pc_ctr_kn_list',
      data() {
      return {
        searchFactor: {
          theme: '',
          moduleId:''
        },
        moduleList :[],
        dialogVisual:{
          initKnThemeVisual: false,
          initUploadAttachVisual:false
        },
        initKnForm:{
          theme:'',
          moduleId:''
        },
        knAttach :{
          headers: {token:""},
          url : "",
          limit : 1,
          name :"file",
          id: ''
        },
        tableData: [],
        pager:{
          currentPage:0,
          totalCount:0,
          pageSize : PAGE_SIZE
        }
      }
    },
    methods : {
      handleCommand(command){
        let index  = command.index
        let row = command.data
        let event = command.event
        switch(event){
          case 'handleDelete' :
              this.handleDelete(index,row)
              break
          case 'handleDeleteAttach' :
              this.handleDeleteAttach(index,row)
              break
          case 'handleEditNotice' :
              let left =  (window.screen.availWidth-10-1000)/2
              let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
              width=1000,height=1000,left=${left},top=100`;
              window.open(SERVICE_URL+ "/#/pc_ctr_kn_edit/" +row.id,"test",params);
              break
          case 'handleViewNotice':
              let left0 =  (window.screen.availWidth-10-1000)/2
              let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
              width=1000,height=1000,left=${left0},top=100`;
              window.open(SERVICE_URL+"/#/pc_ctr_editor_view/" +row.id +"?fileType=" + fileType.SAFE_KNOWLEDGE,"test",params0);
              break
          case 'doActiveNotice':
              this.doActiveKn(index,row)
              break
          case 'uploadAttach':
              this.uploadAttach(index,row)
              break
        }
      },
      indexMethod(index){
          return  index + 1
      },

      uploadAttach(index,row){
        this.dialogVisual.initUploadAttachVisual = true
        this.knAttach.id = row.id
      },
      handleUploadAttach(){
        this.knAttach.url = "/bc/exa/kn/upload?id=" + this.knAttach.id + "&fileArea="+  fileAreaType.ATTACH
      },
      fileUpLoadSuccess(response, file, fileList){
        this.$refs.uploadAttach.clearFiles();
        if(response.code === 0){
          this.dialogVisual.initUploadAttachVisual = false
          this.$message({
                showClose: true,
                message: '上传成功!',
                type: 'success',
                duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
                showClose: true,
                message: response.message,
                type: 'error',
                duration: MESSAGE_DURATION
          })
        }
      },
      fileUpLoadError(err, file, fileList){
        this.$refs.uploadAttach.clearFiles();
        this.$message({
              showClose: true,
              message: err,
              type: 'error',
              duration: MESSAGE_DURATION
        })
      },
      formatContent(row , index){
        if(row.content == null || row.content == ''){
          return ''
        }
        if(row.content.length > 200 ){
          return row.content.substring(0,200)
        }
        return row.content
      },
      handleCurrentChange(val){
        this.knListLoad(val);
      },
      // 获取安全知识列表
      knListLoad(pageNo){
        let url = "/bc/exa/kn/knPage"
        let { 
            theme,
            moduleId
        } = this.searchFactor 
        let dat0 = {
            pageSize: PAGE_SIZE,
            theme,
            pageNo,
            moduleId
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.tableData = [];
                dat.data.forEach(t=>this.tableData.push(t))
                this.pager.totalCount = dat.totalDataCount;
                if(pageNo == 1 ) {
                this.pager.currentPage = 1
              }
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      onSearch(){
        this.knListLoad(1)
      },
      handleCreateKn(){
        this.dialogVisual.initKnThemeVisual = true;
      },
      handleViewEditor(index, row){
        this.$router.replace({ path:'pc_ctr_editor_view', query: {id: row.id}} )
      },
      handleDelete(index, row){
        this.$confirm('即将删除主题['+row.theme+']的安全知识!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doDeleteKn(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！'
          });
        })
      },
      doDeleteKn(row){
        let datBat = {id: row.id}
        let url = "/bc/exa/kn/knDelete"
        let s = JSON.stringify(datBat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.knListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      handleDeleteAttach(index, row){
        this.$confirm('即将删除主题['+row.theme+']的附件!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doDeleteKnAttach(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！'
          });
        })
      },
      doDeleteKnAttach(row){
        let dat = {id: row.id}
        let url = "/bc/exa/kn/deleteAttach"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.knListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },

      // 激活安全知识
      doActiveKn(index,row){
        let actState = row.active === 0 ? 1 : 0
        let dat = {
          id: row.id,
          active: actState
        }
        let url = "/bc/exa/kn/knActive"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.knListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      handleEditKn(index,row){
        this.$router.replace({ path:'pc_ctr_kn_change',query: {id: row.id} })
      },

      // 创建安全知识
      ensureCreate(){
        let theme = this.initKnForm.theme.trim()
        let moduleId = this.initKnForm.moduleId
        try{ 
          stringIsNullOrEmpty(theme,'请输入安全知识主题!')
          stringIsNullOrEmpty(moduleId,'请选择安全知识模块!')
        }catch (e){
          this.$message({
              showClose: true,
              message: e,
              type: 'error',
              duration: MESSAGE_DURATION
          }) 
          return
        }
        let dat = {
          theme : theme,
          moduleId : moduleId
        }
        let url = "/bc/exa/kn/save"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.initKnThemeVisual = false;
            this.$message({
              showClose: true,
              message: '初始化安全知识成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearInitKnForm();
            setTimeout(()=>{
              this.knListLoad(1);
            },200)
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      clearInitKnForm(){
        this.initKnForm.theme = ''
        this.initKnForm.moduleId = ''
      },
      // 查询安全知识模块
      qmListLoad(pageNo){
        let url = "/bc/exa/qm/qmPage"
        let dat0 = {
            pageSize: PAGE_SIZE * 2,
            pageNo
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.moduleList = [];
                dat.data.forEach(t=>this.moduleList.push(t))
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识模块！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      clearUplaodAttachForm(){
        this.knAttach.id = ''
        this.knAttach.url= ""
      }
    },
    created () {
      setTimeout(()=>{getToken(this.knAttach.headers)},200)
      setTimeout(()=>{
        this.qmListLoad(1);
      },200)
      this.knListLoad(1)
    },
    components: {
      
    }
  }
</script>
    
<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_kn_list.vue